export default __webpack_public_path__ + "static/media/about-photo.010dc927.jpg";